import React, { useState, useEffect, useRef } from "react";
import "./style.css";
import ImageGalleryPopup from "../../Components/UI-Controls/PopUp/ImageGalleryPapup/ImageGalleryPopup";
import { security_key, Url,configEditor_upd } from "../../Services/Api";
import axios from "axios";
import { IoClose } from "react-icons/io5";
import { uploadImage } from "../../Services/functions";
import JoditEditor from "jodit-react";
import BottomToust from "../../Components/BottomToust/BottomToust";
import { GrLinkNext } from "react-icons/gr";
import { GrLinkPrevious } from "react-icons/gr";
import MainLoader from "../../Components/UI-Controls/MainLoader/MainLoader";



const Flyers = () => {

    const [tabs, setTabs] = useState([
        {
            id: 1,
            name: "Flyer Images"
        },
        {
            id: 2,
            name: "Flyer Content"
        },
    ]);

    const [selectedTab, setSelectedTab] = useState(1);
    const [flyerData, setFlyerData] = useState({
        flyers: {
            desktop: []
        },
        startContent: "",
        endContent: ""
    });
    const [currentSlide, setCurrentSlide] = useState(0);
    const nextSlide = () => {
        setCurrentSlide((prev) => (prev + 1) % flyerData.flyers.desktop.length);
    };

    const prevSlide = () => {
        setCurrentSlide((prev) => (prev - 1 + flyerData.flyers.desktop.length) % flyerData.flyers.desktop.length);
    };

    const [images, setImages] = useState([]);

    const [modalView, setModalView] = useState(false);
    const [modalData, setModalData] = useState([]);
    const [isUploaded, setIsUploaded] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);
    const [selectedXImage, setSelectedXImage] = useState(null);
    const [uploadedStatus, setUploadedStates] = useState(null);
    const [imageType, setImageType] = useState("");
    const [imageGalleryPopup, setImageGalleryPopup] = useState(false);
    const [imageSendPayload, setImageSendPayload] = useState({
        file: null,
        alt_text: "",
        title: "",
        description: "",
        link_url: "",
    });

    const handleGalleryModalClose = () => {
        setModalView(false);
    };


    const handleFileChange = async (event) => {
        const file = event.target.files[0];
        const api = `${Url}/api/v1/media/flyers/add`;

        if (file) {
            setImageSendPayload((prevData) => ({
                ...prevData,
                file: file,
            }));
            setUploadedStates("loading");
            alert("wait");
            const imagePayloadToSend = new FormData();
            imagePayloadToSend.append("image", file);
            imagePayloadToSend.append("alt_text", imageSendPayload.alt_text);
            imagePayloadToSend.append("title", imageSendPayload.title);
            imagePayloadToSend.append("description", imageSendPayload.description);
            imagePayloadToSend.append("image_url", imageSendPayload.image_url);
            imagePayloadToSend.append("link_url", imageSendPayload.link_url);
            await uploadImage(imagePayloadToSend, api, setUploadedStates);
        }
        setIsUploaded(true);
    };

    const getApi = async () => {
        try {
            const response = await axios.get(`${Url}/api/v1/media/flyers/get`);
            setModalData(response.data.media);
        } catch (error) {
            console.log(error);
        }
    };

    const handleGalleryModalOpen = () => {
        setModalView(true);
    };

    const handleImageSelect = (image) => {
        setFlyerData(prevData => ({
            ...prevData,
            flyers: {
                ...prevData.flyers,
                desktop: [...prevData.flyers.desktop, image]
            }
        }));
        setModalView(false);
    };


    const handleRemoveImage = (indexToRemove) => {
        setFlyerData(prevData => ({
            ...prevData,
            flyers: {
                ...prevData.flyers,
                desktop: prevData.flyers.desktop.filter((_, index) => index !== indexToRemove)
            }
        }));
    };

    const [madeChanging, setMadeChanging] = useState(false);







    const editor = useRef(null);
    const configEditor = {
        buttons: [
            "bold",
            "italic",
            "underline",
            "strikethrough",
            "|",
            "paragraph",
            "fontsize",
            "lineHeight",
            "|",
            "ul",
            "ol",
            "|",
            "link",
            "image",
            "|",
            "align",
            "undo",
            "redo",
        ],
        style: {
            fontFamily: "var(--font-family)",
            fontSize: "var(--font-size-small)",
            lineHeight: "1.6",
            color: "var(--text-color-1)",
            height: "400px",
        },
        toolbarAdaptive: false,
        toolbarSticky: false,
    };

    const [selectedTabEditor, setSelectedTabEditor] = useState("Visual");
    const [startContent, setStartContent] = useState("");

    const [selectedTabEditor1, setSelectedTabEditor1] = useState("Visual");
    const [endContent, setEndContent] = useState("");


    const handleStartContentDataChange = (newContent) => {
        setStartContent(newContent)
    };

    const handleEndContentDataChange = (newContent) => {
        setEndContent(newContent)
    };

    const [loading, setLoading] = useState(false);
    const [openToust, setOpenToust] = useState(false);
    const [message, setMessage] = useState("");

    const handleOpenToust = (message) => {
        setOpenToust(true);
        setMessage(message);

        const timeout = setTimeout(() => {
            setOpenToust(false);
        }, 1500);
        return () => clearTimeout(timeout);
    }

    const handleCloseToust = () => {
        setOpenToust(false);
    }

    const getApiUrl = `${Url}/api/v1/flyer/get`;
    const postApiUrl = `${Url}/api/v1/flyer/add`;

    const fetchData = async () => {
        try {
            const response = await axios.get(getApiUrl);
            if (response.status === 200) {
                console.log(response.data.data, "here is dt")
                const data = response.data.data;
                setFlyerData({
                    flyers: data.flyers,
                    startContent: data.startContent,
                    endContent: data.endContent
                });
                setStartContent(data.startContent)
                setEndContent(data.endContent)
            } else {
            }
        } catch (error) {
            console.error("Error fetching flyers:", error);
        }
    };

    const handleSubmit = async () => {
        const content1 =
            selectedTabEditor === "Visual"
                ? startContent
                : document.getElementById("startContent").value;
        const content2 =
            selectedTabEditor1 === "Visual"
                ? endContent
                : document.getElementById("endContent").value;

        // Immediately update the flyerData state with the new values
        setFlyerData((prevData) => ({
            ...prevData,
            startContent: content1,
            endContent: content2,
        }));

        try {
            setLoading(true);
            const token = sessionStorage.getItem('authToken');
            const headers = {
                Authorization: `Bearer ${token}`,
                'x-api-key': security_key
            };
            // Use the updated content directly for the POST request
            const response = await axios.post(postApiUrl, {
                ...flyerData,
                startContent: content1,
                endContent: content2
            },{headers:headers});

            if (response.status === 200) {
                handleOpenToust("Flyers Updated Successfully!");
                // setPPolicyData(response.data.content);
            } else {
                console.error("Failed to Update flyers:", response.statusText);
                handleOpenToust("Failed to Update flyers!");
            }
        } catch (error) {
            console.error("Error occurred:", error);
            setLoading(false);
            handleOpenToust("An error occurred while updating flyers!");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getApi();
        fetchData();
    }, []);



    return (
        <div className="flyers">
            <h2>Flyer</h2>
            <button onClick={() => { handleSubmit() }} className="add_update_btn">Update</button>
            <div className="flyer_selections_section">
                <div className="flyer_selections_section_left">
                    {
                        tabs.map((item) => {
                            return (
                                <div onClick={() => {
                                    setSelectedTab(item.id)
                                }} className={`flyer_selection_section ${item.id === selectedTab ? "selected" : ""}`}>
                                    {item.name}
                                </div>
                            )
                        })
                    }

                </div>

                {selectedTab === 1 ? <div className="flyer_selections_section_right">
                    <div className="header_flyer_section_right">
                        <p></p>
                        {flyerData.flyers.desktop.length > 0 ? <button onClick={() => { handleGalleryModalOpen() }}>Add +</button> : <div></div>}
                    </div>
                    <div className="flyer_images_list">
                        {flyerData.flyers.desktop.length > 0 && <div className="slider-container">
                            {flyerData.flyers.desktop.map((image, index) => (
                                <div
                                    key={index}
                                    className="image_frame"
                                    style={{
                                        transform: `translateX(-${currentSlide * 50}%)`,
                                        transition: "transform 0.5s ease",
                                    }}
                                >
                                    <div className="slider-image-container">
                                        <img
                                            src={Url + image.image_url}
                                            alt={`Slider image ${index}`}
                                            className="slider-image"
                                        />
                                        <div onClick={() => handleRemoveImage(index)} className="close_btn_1">
                                            <IoClose />
                                        </div>
                                        <div className="numbering_order">
                                            {index + 1}/{flyerData.flyers.desktop.length}
                                        </div>
                                    </div>
                                </div>
                            ))}


                        </div>}
                        {flyerData.flyers.desktop.length > 1 && <div className="slider-controls">
                            <button onClick={prevSlide}><GrLinkNext /></button>
                            <button onClick={nextSlide}><GrLinkPrevious /></button>
                        </div>}

                        {flyerData.flyers.desktop.length === 0 && <div className="blank_frame">
                            <p>Click to open Gallery & Add Flyer</p>
                            <button onClick={() => { handleGalleryModalOpen() }} >Add Image</button>
                        </div>}
                    </div>

                </div> :
                    selectedTab === 2 ?
                        <div className="flyer_selections_section_right">

                            <div className="editorSection_flyer">
                                <p className="heading_1">Start Content</p>
                                <div className="General-Editor-Container">
                                    <div className="General-Editor-Tabs">
                                        <div
                                            className={`Tab ${selectedTabEditor === "Visual" ? "active" : ""}`}
                                            onClick={() => setSelectedTabEditor("Visual")}
                                        >
                                            Visual
                                        </div>
                                        <div
                                            className={`Tab ${selectedTabEditor === "Text" ? "active" : ""}`}
                                            onClick={() => setSelectedTabEditor("Text")}
                                        >
                                            Text
                                        </div>
                                    </div>
                                    <div className="General-Editor-Content">
                                        {selectedTabEditor === "Visual" ? (
                                            <JoditEditor
                                                ref={editor}
                                                value={startContent}
                                                tabIndex={1}
                                                onBlur={handleStartContentDataChange}
                                                config={configEditor_upd}
                                            />
                                        ) : (
                                            <textarea
                                                id="startContent"
                                                name="startContent"
                                                value={startContent}
                                                onChange={(e) => setStartContent(e.target.value)}
                                                className="General-Editor-Text-Area"
                                                placeholder="Start Content"
                                            />
                                        )}
                                    </div>
                                </div>

                            </div>

                            <div className="editorSection_flyer">
                                <p className="heading_1">Last Content</p>
                                <div className="General-Editor-Container">
                                    <div className="General-Editor-Tabs">
                                        <div
                                            className={`Tab ${selectedTabEditor1 === "Visual" ? "active" : ""}`}
                                            onClick={() => setSelectedTabEditor1("Visual")}
                                        >
                                            Visual
                                        </div>
                                        <div
                                            className={`Tab ${selectedTabEditor1 === "Text" ? "active" : ""}`}
                                            onClick={() => setSelectedTabEditor1("Text")}
                                        >
                                            Text
                                        </div>
                                    </div>
                                    <div className="General-Editor-Content">
                                        {selectedTabEditor1 === "Visual" ? (
                                            <JoditEditor
                                                ref={editor}
                                                value={endContent}
                                                tabIndex={1}
                                                onBlur={handleEndContentDataChange}
                                                config={configEditor_upd}
                                            />
                                        ) : (
                                            
                                            <textarea
                                                id="endContent"
                                                name="endContent"
                                                value={endContent}
                                                onChange={(e) => setEndContent(e.target.value)}
                                                className="General-Editor-Text-Area"
                                                placeholder="End Content"
                                            />
                                        )}
                                    </div>
                                </div>
                            </div>


                        </div> : <></>}
            </div>
            <ImageGalleryPopup
                showImageGalleryPopUp={modalView}
                handleModalView={handleGalleryModalClose}
                handleFileChange={handleFileChange}
                imageSendPayload={imageSendPayload}
                setImageSendPayload={setImageSendPayload}
                alt_text={imageSendPayload.alt_text}
                title={imageSendPayload.title}
                data={modalData}
                getData={getApi}
                onImageSelect={handleImageSelect}
            />

            <BottomToust
                message={message}
                showMessage={openToust}
                handleCloseToust={handleCloseToust}
            />
            {loading && <div className="backdrop">
                <div className="loader-container">
                    <MainLoader heading1={"Updating Flyer Content"} />
                </div>
            </div>}
        </div>
    );
};

export default Flyers;
